export const GoogleMapsMixin = {
  computed: {
    googleMapsApiKey() {
      return this.$page.props.customer?.maps_key || '';
    }
  },
  
  methods: {
    loadGoogleMapsExtendedLibrary() {
      if (!document.getElementById('google-extended-script')) {
        const script = document.createElement('script');
        script.id = 'google-extended-script';
        script.type = 'module';
        script.src = 'https://ajax.googleapis.com/ajax/libs/@googlemaps/extended-component-library/0.6.11/index.min.js';
        document.head.appendChild(script);
        
        const apiLoader = document.createElement('gmpx-api-loader');
        apiLoader.setAttribute('key', this.googleMapsApiKey);
        apiLoader.setAttribute('solution-channel', 'GMP_GCC_placepicker_v1');
        document.head.appendChild(apiLoader);
      }
    },
    
    async getAddressFromCoordinates(lat, lng) {
      try {
        const geocoder = new google.maps.Geocoder();
        const response = await geocoder.geocode({
          location: { lat, lng }
        });
        
        if (response.results && response.results[0]) {
          return response.results[0].formatted_address;
        }
        return `Lat: ${lat.toFixed(6)}, Lng: ${lng.toFixed(6)}`;
      } catch (error) {
        console.error('Errore nel geocoding:', error);
        return `Lat: ${lat.toFixed(6)}, Lng: ${lng.toFixed(6)}`;
      }
    }
  }
}
